module.exports = __webpack_public_path__ + "img/loginImg.94614d59.png";